import { render } from "./AdministrarVentas.vue?vue&type=template&id=5190dd10&scoped=true"
import script from "./AdministrarVentas.vue?vue&type=script&lang=js"
export * from "./AdministrarVentas.vue?vue&type=script&lang=js"

import "./AdministrarVentas.vue?vue&type=style&index=0&id=5190dd10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5190dd10"]])

export default __exports__